exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nzxt-logo {\n  margin-top: 2px;\n}", ""]);

// exports
